import styled from "styled-components";

const LoggedMembersContainer = styled.div`
  height: 72px;
  display: flex;
  align-items: center;
`;
export { LoggedMembersContainer };
